export default __webpack_public_path__ + "static/media/featured2.a8a58113.jpg";